import script from "./teamEdition.vue?vue&type=script&setup=true&lang=js"
export * from "./teamEdition.vue?vue&type=script&setup=true&lang=js"

import "./teamEdition.vue?vue&type=style&index=0&id=53e10636&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e10636"]])

export default __exports__